/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import Table from "@mui/material/Table";
import Paper from "@mui/material/Paper";
import { Toolbar } from "@mui/material";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import Typography from "@mui/material/Typography";

import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { connect } from "react-redux";
import {
  EditIcon,
  AddDocumentsIcon,
  PublishIcon,
  AcceptIcon,
  DeleteIcon,
  ViewIcon,
} from "../../../component/icons/icons";
import RequestImage from "../../../asset/images/request.png";
import { withTranslation } from "react-i18next";
import TableContainer from "@mui/material/TableContainer";
import { useNavigate, useLocation } from "react-router-dom";

const ProviderTable = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const t = props.t;
  const updateContract = props.userPerms.includes("CUMULATOR-CONTRACT_UPDATE");
  const changeProviderType = (type) => {
    if (type === "SALES_CHNL_PROVIDER") {
      return t("SALES_CHANNEL_PROVIDER");
    } else if (type === "SOLUTION_PROVIDER") {
      return t("SOLUTION_PROVIDER");
    } else if (type === "SERVICE_PROVIDER") {
      return t("SERVICE_PROVIDER");
    }
  };
  return (
    <div>
      {props.solutionContracts ? (
        // props.solutionContracts.length > 0 &&
        <Paper className="tablePaper">
          {/* <Toolbar>
                        <Typography variant="h6" id="tableTitle"> Contracts </Typography>
                    </Toolbar> */}
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    className="global-custom-sorting-header"
                    onClick={(e) => {
                      props.updateContractSorting("providerType");
                    }}
                  >
                    <b>{t("PROVIDER_TYPE")}</b>
                    {props.contractSortBy === "providerType" ? (
                      <span className="material-icons">
                        {props.contractSortOrder === "DESC"
                          ? "expand_less"
                          : "expand_more"}
                      </span>
                    ) : (
                      <span className="material-icons sorting-indicator-icon">
                        unfold_more
                      </span>
                    )}
                  </TableCell>
                  <TableCell
                    className="global-custom-sorting-header"
                    onClick={(e) => {
                      props.updateContractSorting("title");
                    }}
                  >
                    <b>Title</b>
                    {props.contractSortBy === "title" ? (
                      <span className="material-icons">
                        {props.contractSortOrder === "DESC"
                          ? "expand_less"
                          : "expand_more"}
                      </span>
                    ) : (
                      <span className="material-icons sorting-indicator-icon">
                        unfold_more
                      </span>
                    )}
                  </TableCell>
                  <TableCell
                    className="global-custom-sorting-header"
                    onClick={(e) => {
                      props.updateContractSorting("effectiveDate");
                    }}
                  >
                    <b>{t("EFFECTIVE_DATE")}</b>
                    {props.contractSortBy === "effectiveDate" ? (
                      <span className="material-icons">
                        {props.contractSortOrder === "DESC"
                          ? "expand_less"
                          : "expand_more"}
                      </span>
                    ) : (
                      <span className="material-icons sorting-indicator-icon">
                        unfold_more
                      </span>
                    )}
                  </TableCell>
                  <TableCell
                    className="global-custom-sorting-header"
                    onClick={(e) => {
                      props.updateContractSorting("expiryDate");
                    }}
                  >
                    <b>{t("EXPIRY_DATE")}</b>
                    {props.contractSortBy === "expiryDate" ? (
                      <span className="material-icons">
                        {props.contractSortOrder === "DESC"
                          ? "expand_less"
                          : "expand_more"}
                      </span>
                    ) : (
                      <span className="material-icons sorting-indicator-icon">
                        unfold_more
                      </span>
                    )}
                  </TableCell>
                  <TableCell
                    className="global-custom-sorting-header"
                    onClick={(e) => {
                      props.updateContractSorting("status");
                    }}
                  >
                    <b>{t("STATUS")}</b>
                    {props.contractSortBy === "status" ? (
                      <span className="material-icons">
                        {props.contractSortOrder === "DESC"
                          ? "expand_less"
                          : "expand_more"}
                      </span>
                    ) : (
                      <span className="material-icons sorting-indicator-icon">
                        unfold_more
                      </span>
                    )}
                  </TableCell>
                  <TableCell align="center">
                    <b>{t("ACTION")}</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.solutionContracts.map((item, i) => (
                  <TableRow
                    key={i}
                    onClick={(e) => {
                      navigate(`${location.pathname}/${item.id}`);
                    }}
                    style={{ cursor: "pointer" }}
                    hover
                  >
                    <TableCell style={{ verticalAlign: "top" }}>
                      {changeProviderType(item.parties.to.type)}
                    </TableCell>
                    <TableCell style={{ verticalAlign: "top" }}>
                      {item.title}
                    </TableCell>
                    <TableCell style={{ verticalAlign: "top" }}>
                      {item.effectiveDate
                        ? item.effectiveDate.split(" ")[0]
                        : ""}
                    </TableCell>
                    <TableCell style={{ verticalAlign: "top" }}>
                      {item.expiryDate ? item.expiryDate.split(" ")[0] : ""}
                    </TableCell>
                    <TableCell style={{ verticalAlign: "top" }}>
                      <div style={{ maxWidth: "300px", whiteSpace: "normal" }}>
                        {item.status}
                      </div>
                    </TableCell>
                    <TableCell align="right">
                      {/* <Button style={{ marginLeft: '15px' }} onClick={(e) => { e.stopPropagation(); props.requestContract(item) }}> Request </Button> */}
                      <Tooltip
                        title={t("Request Contract")}
                        style={{ paddingTop: 0, paddingBottom: 0 }}
                      >
                        {/* <svg onClick={(e) => { e.stopPropagation(); props.requestContract(item) }} style={{ width: '24px' }} version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1000 1000" enableBackground="new 0 0 1000 1000" fill={'#000'}>
                                                <g>
                                                    <g transform="translate(0.000000,511.000000) scale(0.100000,-0.100000)">
                                                        <path d="M602.6,3588.1C326.2,3035.3,100,2578.7,100,2574.5c0-25.1,483.8-165.4,500.5-148.7c27.2,29.3,1011.5,1834.5,1003.1,1842.9c-12.6,8.4-446.1,295.3-471.2,312C1113.6,4591.3,954.4,4291.8,602.6,3588.1z" />
                                                        <path d="M5178.5,4543.1c-102.6-27.2-617.8-219.9-1141.3-427.2c-523.6-207.3-998.9-389.5-1053.4-404.2c-196.9-48.2-318.3-18.8-707.9,171.7c-194.8,94.2-356,169.6-360.2,163.3c-25.1-31.4-978-1681.6-973.8-1683.7c12.6-10.5,881.7-314.1,1233.5-431.4c733-242.9,1078.5-266,1505.7-98.4c169.6,64.9,728.8,349.7,1005.2,513.1c603.1,351.8,693.2,377,1413.6,393.7c276.4,6.3,582.2,23,680.6,33.5c360.2,44,485.9,165.4,328.8,322.5c-54.5,54.5-104.7,77.5-234.6,106.8c-150.8,35.6-263.9,39.8-1141.3,39.8c-1099.5-2.1-1164.4-8.4-1801-190.6c-48.2-14.7-50.3-12.6-20.9,23c62.8,77.5,370.7,291.1,534,368.6c293.2,142.4,356,148.7,1434.5,138.2c1030.4-8.4,1107.9-16.8,1357.1-129.8c211.5-96.3,297.4-209.4,297.4-389.5c0-155-37.7-259.7-129.8-364.4c-169.6-192.7-467-280.6-1028.3-297.4c-301.6-10.5-345.5-16.7-293.2-37.7c31.4-14.7,203.1-94.2,379-175.9c538.2-253.4,753.9-310,971.7-245c62.8,16.8,150.8,64.9,194.8,102.6l83.8,71.2l108.9-60.7c198.9-113.1,487.9-163.3,689-121.5c150.8,31.4,259.7,127.7,259.7,228.3c0,35.6,4.2,64.9,8.4,64.9c4.2,0,111-33.5,236.6-75.4c387.4-129.8,680.6-102.6,833.5,79.6c64.9,77.5,69.1,184.3,8.4,280.6c-23,39.8-119.4,121.5-213.6,184.3c-314.1,205.2-3340.3,1734-3637.7,1836.6C5794.2,4603.8,5427.7,4610.1,5178.5,4543.1z" /><path d="M5000.5,1556.8v-167.5h251.3h251.3v-167.5v-167.5h167.5h165.4l6.3,163.3l6.3,161.3l257.6,6.3l257.6,6.3l-6.3,161.3l-6.3,161.3l-674.3,6.3l-676.4,4.2V1556.8z" /><path d="M5501,859.4c-182.2-52.4-299.5-190.6-324.6-383.2c-14.7-127.7,8.4-182.2,102.6-232.5c100.5-56.5,705.8-54.4,806.3,0c108.9,60.7,127.8,157.1,64.9,362.3c-23.1,73.3-123.6,175.9-224.1,226.2C5834,880.3,5620.4,892.9,5501,859.4z" /><path d="M5383.7-13.9c-383.2-33.5-712-121.5-1019.9-274.3c-697.4-349.7-1177-1089-1292.1-2002.1l-23-190.6l-69.1-12.6c-96.3-18.9-242.9-155-320.4-299.5c-64.9-123.5-155-400-182.2-567.5l-14.7-88h3218.8h3216.7l-14.6,79.6c-50.3,274.4-178,599-293.2,735.1c-56.5,67-190.6,148.7-245,148.7c-35.6,0-56.6,62.8-56.6,167.5c0,39.8-18.9,161.3-41.9,268.1C8032.9-1040.1,7419.3-346.9,6529.2-110.2C6183.7-20.2,5748.1,17.5,5383.7-13.9z M5406.8-361.5c83.8-81.7,27.2-155-165.4-217.8c-324.6-104.7-632.5-286.9-860.7-513.1c-236.6-234.6-402.1-511-477.5-795.8c-46.1-178-138.2-242.9-226.2-163.3c-52.4,46.1-48.2,119.4,16.8,324.6c173.8,548.7,540.3,955,1105.7,1223c186.4,87.9,439.8,171.7,529.8,173.8C5354.4-328,5390-342.7,5406.8-361.5z M4380.6-2686.1c48.2-18.9,44-127.8-6.3-155c-58.6-31.4-1239.8-29.3-1308.9,4.2c-56.5,25.1-92.1,94.2-60.7,121.5c8.4,8.4,35.6,20.9,58.6,27.2C3126.1-2673.6,4342.9-2671.5,4380.6-2686.1z" /><path d="M1984.8-3976.2c-161.3-104.7-343.4-280.6-360.2-347.6l-12.6-46.1h4060.7c3327.7,0,4060.7,4.2,4060.7,27.2c0,73.3-173.8,245-381.2,379.1l-119.4,75.4h-3556h-3556L1984.8-3976.2z" />
                                                    </g>
                                                </g>
                                            </svg> */}
                        <img
                          src={RequestImage}
                          onClick={(e) => {
                            e.stopPropagation();
                            props.requestContract(item);
                          }}
                          className={"requestContractIcon"}
                          alt={t("Request Contract")}
                        />
                      </Tooltip>{" "}
                      &nbsp;
                      <Tooltip title={t("VIEW_REQUESTS")}>
                        <IconButton
                          color="primary"
                          aria-label="View Requests"
                          component="span"
                          onClick={(e) => {
                            e.stopPropagation();
                            props.viewRequestors(
                              item.id,
                              item.parties.from.id,
                              item.title,
                            );
                          }}
                          style={{
                            color: "#000",
                            paddingTop: 0,
                            paddingBottom: 0,
                            position: "relative",
                            top: "0",
                          }}
                        >
                          <ViewIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
                {props.solutionContracts.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      {t("NO_CONTRACTS_FOUND")}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      ) : (
        <>
          <Paper className="tablePaper">
            <TableContainer>
              <Table className="contractsListingTable">
                {/* Inbound contracts */}
                {props.inboundContracts.length > 0 && (
                  <>
                    <TableHead></TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={7}>
                          <h3 style={{ margin: 0 }}>
                            {t("INBOUND_CONTRACTS")}
                          </h3>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                    <TableHead>
                      <TableRow scope="col">
                        <TableCell colSpan={7}>
                          <div
                            style={{ width: "13%", marginRight: "10px" }}
                            className="global-custom-sorting-header"
                            onClick={(e) => {
                              props.updateInboundSorting("providerName");
                            }}
                          >
                            <b>{t("FROM")}</b>
                            {props.inboundSortBy === "providerName" ? (
                              <span className="material-icons">
                                {props.inboundSortOrder === "DESC"
                                  ? "expand_less"
                                  : "expand_more"}
                              </span>
                            ) : (
                              <span className="material-icons sorting-indicator-icon">
                                unfold_more
                              </span>
                            )}
                          </div>
                          <div
                            style={{
                              width: "13%",
                              marginRight: "10px",
                              marginLeft: "10px",
                            }}
                            className="global-custom-sorting-header"
                            onClick={(e) => {
                              props.updateInboundSorting("providerType");
                            }}
                          >
                            <b>{t("PROVIDER_TYPE")}</b>
                            {props.inboundSortBy === "providerType" ? (
                              <span className="material-icons">
                                {props.inboundSortOrder === "DESC"
                                  ? "expand_less"
                                  : "expand_more"}
                              </span>
                            ) : (
                              <span className="material-icons sorting-indicator-icon">
                                unfold_more
                              </span>
                            )}
                          </div>
                          <div
                            style={{
                              width: "13%",
                              marginRight: "10px",
                              marginLeft: "10px",
                            }}
                            className="global-custom-sorting-header"
                            onClick={(e) => {
                              props.updateInboundSorting("title");
                            }}
                          >
                            <b>{t("TITLE")}</b>
                            {props.inboundSortBy === "title" ? (
                              <span className="material-icons">
                                {props.inboundSortOrder === "DESC"
                                  ? "expand_less"
                                  : "expand_more"}
                              </span>
                            ) : (
                              <span className="material-icons sorting-indicator-icon">
                                unfold_more
                              </span>
                            )}
                          </div>
                          <div
                            style={{
                              width: "13%",
                              marginRight: "10px",
                              marginLeft: "10px",
                            }}
                            className="global-custom-sorting-header"
                            onClick={(e) => {
                              props.updateInboundSorting("effectiveDate");
                            }}
                          >
                            <b>{t("EFFECTIVE_DATE")}</b>
                            {props.inboundSortBy === "effectiveDate" ? (
                              <span className="material-icons">
                                {props.inboundSortOrder === "DESC"
                                  ? "expand_less"
                                  : "expand_more"}
                              </span>
                            ) : (
                              <span className="material-icons sorting-indicator-icon">
                                unfold_more
                              </span>
                            )}
                          </div>
                          <div
                            style={{
                              width: "13%",
                              marginRight: "10px",
                              marginLeft: "10px",
                            }}
                            className="global-custom-sorting-header"
                            onClick={(e) => {
                              props.updateInboundSorting("expiryDate");
                            }}
                          >
                            <b>{t("EXPIRY_DATE")}</b>
                            {props.inboundSortBy === "expiryDate" ? (
                              <span className="material-icons">
                                {props.inboundSortOrder === "DESC"
                                  ? "expand_less"
                                  : "expand_more"}
                              </span>
                            ) : (
                              <span className="material-icons sorting-indicator-icon">
                                unfold_more
                              </span>
                            )}
                          </div>
                          <div
                            style={{
                              width: "12%",
                              marginRight: "10px",
                              marginLeft: "10px",
                            }}
                            className="global-custom-sorting-header"
                            onClick={(e) => {
                              props.updateInboundSorting("status");
                            }}
                          >
                            <b>{t("STATUS")}</b>
                            {props.inboundSortBy === "status" ? (
                              <span className="material-icons">
                                {props.inboundSortOrder === "DESC"
                                  ? "expand_less"
                                  : "expand_more"}
                              </span>
                            ) : (
                              <span className="material-icons sorting-indicator-icon">
                                unfold_more
                              </span>
                            )}
                          </div>
                          <div
                            style={{
                              width: "12%",
                              textAlign: "right",
                              marginLeft: "10px",
                            }}
                          >
                            {props.userPerms.includes(
                              "CUMULATOR-CONTRACT_UPDATE",
                            ) ? (
                              <b style={{ position: "relative", top: "6px" }}>
                                {t("ACTION")}
                              </b>
                            ) : (
                              ""
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {props.inboundContracts.map(
                        (item, i) =>
                          item.status !== "DRAFT" && (
                            <TableRow
                              key={i}
                              title="Inbound"
                              onClick={(e) => {
                                navigate(
                                  `contract/${item.parties.from.id}/${item.id}`,
                                );
                              }}
                              style={{ cursor: "pointer" }}
                              hover
                            >
                              <TableCell colSpan={7}>
                                <div
                                  style={{
                                    width: "13%",
                                    minHeight: "5px",
                                    marginRight: "10px",
                                  }}
                                >
                                  {item.parties.from.name}
                                </div>
                                <div
                                  style={{
                                    width: "13%",
                                    minHeight: "5px",
                                    marginRight: "10px",
                                    marginLeft: "10px",
                                  }}
                                >
                                  {changeProviderType(item.parties.from.type)}
                                </div>
                                <div
                                  style={{
                                    width: "13%",
                                    minHeight: "5px",
                                    marginRight: "10px",
                                    marginLeft: "10px",
                                  }}
                                >
                                  {item.title}
                                </div>
                                <div
                                  style={{
                                    width: "13%",
                                    minHeight: "5px",
                                    marginRight: "10px",
                                    marginLeft: "10px",
                                  }}
                                >
                                  {item.effectiveDate
                                    ? item.effectiveDate.split(" ")[0]
                                    : ""}
                                </div>
                                <div
                                  style={{
                                    width: "13%",
                                    minHeight: "5px",
                                    marginRight: "10px",
                                    marginLeft: "10px",
                                  }}
                                >
                                  {item.expiryDate
                                    ? item.expiryDate.split(" ")[0]
                                    : ""}
                                </div>
                                <div
                                  style={{
                                    width: "20%",
                                    minHeight: "5px",
                                    marginRight: "10px",
                                    marginLeft: "10px",
                                  }}
                                >
                                  {item.status}
                                </div>
                                <div
                                  style={{
                                    width: "15%",
                                    textAlign: "right",
                                    minHeight: "5px",
                                    marginLeft: "10px",
                                  }}
                                >
                                  {item.status === "Published" &&
                                    props.userPerms.includes(
                                      "CUMULATOR-CONTRACT_UPDATE",
                                    ) && (
                                      <Tooltip title={t("ACCEPT_CONTRACT")}>
                                        <IconButton
                                          color="primary"
                                          aria-label="Accept Contract"
                                          component="span"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            props.acceptContract(item, item.id);
                                          }}
                                          style={{
                                            color: "#000",
                                            paddingTop: 0,
                                            paddingBottom: 0,
                                          }}
                                        >
                                          <AcceptIcon />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                </div>
                              </TableCell>
                            </TableRow>
                          ),
                      )}
                    </TableBody>
                  </>
                )}
                {props.outboundContracts.length > 0 && (
                  <>
                    {/* Outbound contracts */}
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={7}>
                          <h3 style={{ marginBottom: 0 }}>
                            {t("OUTBOUND_CONTRACTS")}
                          </h3>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                    <TableHead>
                      <TableRow scope="col">
                        <TableCell colSpan={7}>
                          <div
                            style={{ width: "13%" }}
                            className="global-custom-sorting-header"
                            onClick={(e) => {
                              props.updateOutboundSorting("providerName");
                            }}
                          >
                            <b>{t("TO")}</b>
                            {props.outboundSortBy === "providerName" ? (
                              <span className="material-icons">
                                {props.outboundSortOrder === "DESC"
                                  ? "expand_less"
                                  : "expand_more"}
                              </span>
                            ) : (
                              <span className="material-icons sorting-indicator-icon">
                                unfold_more
                              </span>
                            )}
                          </div>
                          <div
                            style={{ width: "13%" }}
                            className="global-custom-sorting-header"
                            onClick={(e) => {
                              props.updateOutboundSorting("providerType");
                            }}
                          >
                            <b>{t("PROVIDER_TYPE")}</b>
                            {props.outboundSortBy === "providerType" ? (
                              <span className="material-icons">
                                {props.outboundSortOrder === "DESC"
                                  ? "expand_less"
                                  : "expand_more"}
                              </span>
                            ) : (
                              <span className="material-icons sorting-indicator-icon">
                                unfold_more
                              </span>
                            )}
                          </div>
                          <div
                            style={{ width: "13%" }}
                            className="global-custom-sorting-header"
                            onClick={(e) => {
                              props.updateOutboundSorting("title");
                            }}
                          >
                            <b>{t("TITLE")}</b>
                            {props.outboundSortBy === "title" ? (
                              <span className="material-icons">
                                {props.outboundSortOrder === "DESC"
                                  ? "expand_less"
                                  : "expand_more"}
                              </span>
                            ) : (
                              <span className="material-icons sorting-indicator-icon">
                                unfold_more
                              </span>
                            )}
                          </div>
                          <div
                            style={{ width: "13%" }}
                            className="global-custom-sorting-header"
                            onClick={(e) => {
                              props.updateOutboundSorting("effectiveDate");
                            }}
                          >
                            <b>{t("EFFECTIVE_DATE")}</b>
                            {props.outboundSortBy === "effectiveDate" ? (
                              <span className="material-icons">
                                {props.outboundSortOrder === "DESC"
                                  ? "expand_less"
                                  : "expand_more"}
                              </span>
                            ) : (
                              <span className="material-icons sorting-indicator-icon">
                                unfold_more
                              </span>
                            )}
                          </div>
                          <div
                            style={{ width: "13%" }}
                            className="global-custom-sorting-header"
                            onClick={(e) => {
                              props.updateOutboundSorting("expiryDate");
                            }}
                          >
                            <b>{t("EXPIRY_DATE")}</b>
                            {props.outboundSortBy === "expiryDate" ? (
                              <span className="material-icons">
                                {props.outboundSortOrder === "DESC"
                                  ? "expand_less"
                                  : "expand_more"}
                              </span>
                            ) : (
                              <span className="material-icons sorting-indicator-icon">
                                unfold_more
                              </span>
                            )}
                          </div>
                          <div
                            style={{ width: "20%" }}
                            className="global-custom-sorting-header"
                            onClick={(e) => {
                              props.updateOutboundSorting("status");
                            }}
                          >
                            <b>{t("STATUS")}</b>
                            {props.outboundSortBy === "status" ? (
                              <span className="material-icons">
                                {props.outboundSortOrder === "DESC"
                                  ? "expand_less"
                                  : "expand_more"}
                              </span>
                            ) : (
                              <span className="material-icons sorting-indicator-icon">
                                unfold_more
                              </span>
                            )}
                          </div>
                          <div style={{ width: "15%", textAlign: "right" }}>
                            {props.userPerms.includes(
                              "CUMULATOR-CONTRACT_UPDATE",
                            ) ? (
                              <b style={{ position: "relative", top: "6px" }}>
                                {" "}
                                {t("ACTION")}{" "}
                              </b>
                            ) : (
                              ""
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {props.outboundContracts.map((item, i) => (
                        <React.Fragment key={i}>
                          <TableRow
                            onClick={(e) => {
                              navigate(`contract/${item.id}`);
                            }}
                            style={{ cursor: "pointer" }}
                            hover
                          >
                            <TableCell colSpan={7}>
                              <div style={{ width: "13%", minHeight: "5px" }}>
                                {item.parties.to.name}
                              </div>
                              <div style={{ width: "13%", minHeight: "5px" }}>
                                {changeProviderType(item.parties.to.type)}
                              </div>
                              <div style={{ width: "13%", minHeight: "5px" }}>
                                {item.title}
                              </div>
                              <div style={{ width: "13%", minHeight: "5px" }}>
                                {item.effectiveDate
                                  ? item.effectiveDate.split(" ")[0]
                                  : ""}
                              </div>
                              <div style={{ width: "13%", minHeight: "5px" }}>
                                {item.expiryDate
                                  ? item.expiryDate.split(" ")[0]
                                  : ""}
                              </div>
                              <div style={{ width: "20%", minHeight: "5px" }}>
                                {item.status}
                              </div>
                              <div
                                style={{
                                  width: "15%",
                                  textAlign: "right",
                                  minHeight: "5px",
                                }}
                              >
                                {(item.status === "Published" ||
                                  item.status === "Draft") &&
                                  props.userPerms.includes(
                                    "CUMULATOR-CONTRACT_UPDATE",
                                  ) && (
                                    <>
                                      <Tooltip title={t("EDIT_CONTRACT")}>
                                        <IconButton
                                          color="primary"
                                          aria-label="Edit Contract"
                                          component="span"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            props.editContract(item);
                                          }}
                                          style={{
                                            color: "#000",
                                            paddingTop: 0,
                                            paddingBottom: 0,
                                          }}
                                        >
                                          <EditIcon />
                                        </IconButton>
                                      </Tooltip>{" "}
                                      &nbsp;
                                      <Tooltip title={t("ADD_DOCUMENTS")}>
                                        <IconButton
                                          color="primary"
                                          aria-label="Add Documents"
                                          component="span"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            props.addDocuments(
                                              item.id,
                                              item.parties.to,
                                              item.title,
                                              item.effectiveDate,
                                              item.expiryDate,
                                            );
                                          }}
                                          style={{
                                            color: "#000",
                                            paddingTop: 0,
                                            paddingBottom: 0,
                                          }}
                                        >
                                          <AddDocumentsIcon />
                                        </IconButton>
                                      </Tooltip>{" "}
                                      &nbsp;
                                      <Tooltip title={t("DELETE_CONTRACT")}>
                                        <IconButton
                                          color="primary"
                                          aria-label="Delete Contract"
                                          component="span"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            props.deleteContract(item);
                                          }}
                                          style={{
                                            color: "#000",
                                            paddingTop: 0,
                                            paddingBottom: 0,
                                          }}
                                        >
                                          <DeleteIcon />
                                        </IconButton>
                                      </Tooltip>{" "}
                                      &nbsp;
                                    </>
                                  )}
                                {item.status === "Draft" &&
                                  item.items.length > 0 &&
                                  props.userPerms.includes(
                                    "CUMULATOR-CONTRACT_UPDATE",
                                  ) && (
                                    <Tooltip title={t("PUBLISH_CONTRACT")}>
                                      <IconButton
                                        color="primary"
                                        aria-label="Publish Contract"
                                        component="span"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          props.publishContract(item, item.id);
                                        }}
                                        style={{
                                          color: "#000",
                                          paddingTop: 0,
                                          paddingBottom: 0,
                                        }}
                                      >
                                        <PublishIcon />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                {item.parties.to.name === "All" &&
                                  item.status === "Published" && (
                                    <Tooltip title={t("VIEW_REQUESTS")}>
                                      <IconButton
                                        color="primary"
                                        aria-label="View Requests"
                                        component="span"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          props.viewRequestors(
                                            item.id,
                                            item.title,
                                            true,
                                          );
                                        }}
                                        style={{
                                          color: "#000",
                                          paddingTop: 0,
                                          paddingBottom: 0,
                                        }}
                                      >
                                        <ViewIcon />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                              </div>
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      ))}
                    </TableBody>
                  </>
                )}
              </Table>
            </TableContainer>
            {props.searching ? (
              <Paper>
                <Toolbar>
                  <Typography variant="h6" id="tableTitle" align="center">
                    {t("SEARCHING")}
                  </Typography>
                </Toolbar>
              </Paper>
            ) : (
              props.outboundContracts.length === 0 &&
              props.inboundContracts.length === 0 && (
                <Paper>
                  <Toolbar>
                    <Typography variant="h6" id="tableTitle" align="center">
                      {t("NO_CONTRACTS_FOUND")}
                    </Typography>
                  </Toolbar>
                </Paper>
              )
            )}
          </Paper>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    tenantData: state.auth.tenantData,
    userPerms: state.auth.userPerms,
  };
};

export default connect(mapStateToProps)(
  withTranslation("translations")(ProviderTable),
);
